<template>
    <div class="download_documents_list">
      <div class="selectall">
      </div>
        <vs-tabs >
            <vs-tab label="Saved Documents" @click="changedDocumentsTab('savedDocuments')" >
                <div class="con-tab-ejemplo" v-if="documentActiveTab=='savedDocuments'" >
                    <div class="doc_modal">
                      <vs-checkbox v-if="checkActiveDocuments(usaDocumentsList)||checkActiveDocuments(foreignDocsList)"
                        v-model="completeDocsSelected" 
                        @change="selectCompleteDocs" 
                        :name="'selectCompleteDocs'" class="select__all"
                        >Select All
                      </vs-checkbox>
                        <VuePerfectScrollbar class="scrollbardoc">
                            <vs-row vs-w="12">
                                <!-- v-if="checkActiveDocuments(usaDocumentsList)" -->
                                <template v-if="checkActiveDocuments(usaDocumentsList)"   >
                                    <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                                        <h2 class="small-header">USA Company Documents</h2>
                                       <div class="list_elements drag-items">
                                        <vs-collapse accordion>
                                          <draggable :list="usaDocumentsList" group="people">
                                            <template v-for="(categoryDocs, index) in usaDocumentsList">
                                              <vs-collapse-item   :key="index" >
                                                <div slot="header" class="d_header_title d_header_titlev2"  :id="'docTypeOrder_ben_'+categoryDocs['category']"  >
                                                  <vs-checkbox v-model="categoryDocs['isSelected']" 
                                                    @change="selectAll('usaDocumentsList' ,categoryDocs['category'])" 
                                                    :name="'selecteAll'" class="">
                                                  </vs-checkbox>
                                                    {{categoryDocs['category'] | formatdoctype}}
                                                </div>
                                                <div>
                                                  <div class="dragBox" v-if="categoryDocs['documents'] && categoryDocs['documents'].length > 0">
                                                    <div class="dragNested">
                                                      <draggable >
                                                      <template  v-for="(document,sindex) in  categoryDocs['documents']">
                                                        <div
                                                          :id="'order_ben_'+categoryDocs['category']+'_docPath_'+document['path']"
                                                          :docPath="document['path']"
                                                          
                                                          v-bind:key="sindex"
                                                          class="drab_sublist"
                                                           v-if=" checkProperty(document,'path') && (checkProperty(document,'status')=='' || checkProperty(document,'status') )"
                                                        >
                                                          <div class="subdragHead" :documentssubcategory="categoryDocs['category']" :categoryOrder="index"  :documentPath="checkProperty(document ,'path')"  
                                                          >
                                                          <vs-checkbox 
                                                           @change="selectSingle('usaDocumentsList' ,categoryDocs['category'])" :name="'selecteAll'" v-model="document['isSelected']" class="">
                                                          </vs-checkbox>
                                                          {{document.name}}</div>
                                                          <div class="downloadPopup-actions d-flex align-center">
                                                              <span @click="downloadfile(document)" class="sub_delete" >
                                                                <img width="14" src="@/assets/images/main/eye.png" />
                                                                <em>View/Download</em>
                                                              </span>
                                                            </div>
                                                        </div>
                                                        </template>
                                                      </draggable>
                                                    </div>
                                                  </div>
                                                </div>
                                              </vs-collapse-item>
                                            </template>
                                          </draggable>
                                        </vs-collapse>
                                      </div>
                                    </vs-col>
                                </template>
                                <template v-if="!checkActiveDocuments(usaDocumentsList)">
                                  <div class="vs-col vs-xs-12 vs-sm-12 vs-lg-12">
                                     <NoDataFound ref="NoDataFoundRef" :loading="false" :checkLocading="false"  content="" :heading="'No Documents Found'" type='Documents' />
                                  </div>  
                                </template>
                                <!-- v-if="checkActiveDocuments(foreignDocsList)" -->
                                <template  v-if="checkActiveDocuments(foreignDocsList)"  >
                                    <vs-col vs-lg="12" vs-sm="12" vs-xs="12">
                                        <h2 class="small-header">Foreign Company Documents</h2>
                                       <div class="list_elements drag-items">
                                        <vs-collapse accordion>
                                          <draggable :list="foreignDocsList" group="foreignCompanyDocuments">
                                            <template v-for="(categoryDocs, index) in foreignDocsList">
                                                <!-----{"category":category,"documents":categoryDocuments} v-if="checktSavedDocuments(categoryDocs['documents'])"-->
                                              <vs-collapse-item    :key="index" >
                                                <div slot="header" class="d_header_title d_header_titlev2" :id="'docTypeOrder_sup_'+categoryDocs['category']" >
                                                 <!--- {{1+index}} - {{categoryDocs['category'] | formatdoctype}} --->
                                                 <vs-checkbox v-model="categoryDocs['isSelected']"  
                                                    @change="selectAll('foreignDocsList' ,categoryDocs['category'])" 
                                                    :name="'selecteAll'" class="">
                                                  </vs-checkbox>
                                                  {{categoryDocs['category'] | formatdoctype}}
                                                  
                                                  <!-- <span  @click="moveToTrash('foreignDocsList',categoryDocs['category'])"  >
                                                    <img src="@/assets/images/main/delete-row-img.svg" />
                                                    <em>Remove from the list</em>
                                                  </span> -->
                                                </div>
                                                <div>
                                                  <div class="dragBox" v-if="categoryDocs['documents'] && categoryDocs['documents'].length > 0">
                                                    <div class="dragNested">
                                                      <draggable >
                                                      <template  v-for="(document,sindex) in  categoryDocs['documents']">
                                                        <div
                                                          :id="'order_sup_'+categoryDocs['category']+'_docPath_'+document['path']"
                                                          :docPath="document['path']"
                                                          
                                                          v-bind:key="sindex"
                                                          class="drab_sublist"
                                                           v-if=" checkProperty(document,'path')  && (checkProperty(document,'status')=='' || checkProperty(document,'status') )"
                                                        >
                                                          <div class="subdragHead" :documentssubcategory="categoryDocs['category']" :categoryOrder="index"  :documentPath="checkProperty(document ,'path')"   >
                                                            
                                                            <vs-checkbox 
                                                              @change="selectSingle('foreignDocsList' ,categoryDocs['category'])" :name="'selecteAll'" v-model="document['isSelected']" class="">
                                                            </vs-checkbox>
                                                            {{document.name}}</div>
                                                         
                                                          <div class="downloadPopup-actions d-flex align-center">
                                                              <span @click="downloadfile(document)" class="sub_delete" >
                                                                <img width="14" src="@/assets/images/main/eye.png" />
                                                                <em>View/Download</em>
                                                              </span>
                                                                <!-- <span  @click="document['isTrashDocument']=true;savedDocumentsAction()"  class="sub_delete ml-4"   >
                                                                  <img src="@/assets/images/main/cross.svg" />
                                                                  <em>Remove from the list</em>
                                                                </span> -->
                                                            </div>
                                                        </div>
                                                        </template>
                                                      </draggable>
                                                    </div>
                                                  </div>
                                                </div>
                                              </vs-collapse-item>
                                            </template>
                                          </draggable>
                                        </vs-collapse>
                                      </div>
                                    </vs-col>
                                </template>
                                <template v-if="!checkActiveDocuments(foreignDocsList)" >
                                  <div class="vs-col vs-xs-12 vs-sm-12 vs-lg-12">
                                     <NoDataFound ref="NoDataFoundRef" :loading="false" :checkLocading="false"  content="" :heading="'No Documents Found'" type='Documents' />
                                  </div>  
                                </template>
                            </vs-row>
                        </VuePerfectScrollbar>    
                    </div>
                </div>
            </vs-tab>
        </vs-tabs>
        <div class="popup-footer relative">
            <button  @click="$emit('closeMe');downloadDocList = false" class="cancel" type="filled" color="dark">Cancel</button>
            <vs-button
                v-if="documentActiveTab=='savedDocuments'"
                color="success"
                :disabled="filesDownloading|| (!checkDocsSelected(usaDocumentsList) && !checkDocsSelected(foreignDocsList) )"
                @click="downloadcombine"
                class="marl15 save"
                type="filled"
                >Download
            </vs-button>
            <span v-if="filesDownloading" class="loader"><img src="@/assets/images/main/loader.gif"></span>
        </div>
    </div>
</template>
<script>
import JQuery from "jquery";
import draggable from "vuedraggable";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import NoDataFound from "@/views/common/noData.vue";

import { XIcon } from 'vue-feather-icons'
import * as _ from "lodash";
export default {
computed:{
    checktSavedDocuments(){
        let _self= this;
        return (docsList)=>{
            let savedDocs=_.filter(docsList ,{"isTrashDocument":false});
            if(savedDocs && _self.checkProperty(savedDocs ,'length')>0){
                return true
            }else{
                return false;
            }
        }
    },
    checktTrashedDocuments(){
        let _self= this;
        return (docsList)=>{
            let savedDocs=_.filter(docsList ,{"isTrashDocument":true});
            if(savedDocs &&savedDocs.length>0){
                return true
            }else{
                return false;
            }
        }
    },
    checkDocsSelected(){
        return (allDocs)=>{
            let count =0;
            if(allDocs.length>0){
                _.forEach(allDocs ,(catDocs)=>{
                    if(_.has(catDocs,'documents') && catDocs['documents'].length>0){
                        // count =count+1;
                    let activDocs = _.filter(catDocs['documents'] ,{"isSelected":true});
                        if(activDocs && activDocs.length>0){
                            count =count+1;
                        }
                    }
                });
                if(count>0){
                return true;
                }else{
                    return false;
                }
                
            }else{
                return false;
            }

        }
    },
    checkActiveDocuments(){
        let _self =this;
        return (allDocs)=>{
            let count =0;
            if(allDocs.length>0){
                _.forEach(allDocs ,(catDocs)=>{
                //alert(JSON.stringify(catDocs))
                    if(_.has(catDocs,'documents') && catDocs['documents'].length>0){
                        count =count+1;
                    // let activDocs = _.filter(catDocs['documents'] ,{"isTrashDocument":false});
                    //     if(activDocs && activDocs.length>0){
                    //         count =count+1;
                    //     }
                    }

                });
                if(count>0){
                return true;
                }else{
                    return false;
                }
                
            }else{
                return false;
            }

        }
    },
    checkInActiveDocuments(){
        let _self =this;
        return (allDocs)=>{
            let count =0;
            if(allDocs.length>0){
                _.forEach(allDocs ,(catDocs)=>{
                    if(_.has(catDocs,'documents') && catDocs['documents'].length>0){
                    let activDocs = _.filter(catDocs['documents'] ,{"isTrashDocument":true});
                        if(activDocs && activDocs.length>0){
                            count =count+1;
                        }
                    }
                });
                if(count>0){
                    return true;
                }else{
                    return false;
                }
            }else{
                return false;
            }
        }
    },
    checkChildActiveDocuments(){
        let count =0;
        this.childrenDocuments.map((child ,indx)=>{
            if(_.has( child ,'documents')){
                child['documents'].map((items)=>{
                if( _.has(items ,'documents') && items['documents'].length>0 ){
                    let alctiveDocuments = _.filter(items['documents'] ,{"isTrashDocument":false})
                    if(alctiveDocuments && alctiveDocuments.length>0){
                        count =count+1;
                    }
                }
            });

            }
        });
        if(count>0){
            return true
        }else{
            return false;
        }
    },
    checkChildInActiveDocuments(){
        let count =0;
        this.childrenDocuments.map((child ,indx)=>{
            if(_.has( child ,'documents')){
                child['documents'].map((items)=>{
                    if( _.has(items ,'documents') && items['documents'].length>0 ){
                        let alctiveDocuments = _.filter(items['documents'] ,{"isTrashDocument":true})
                        if(alctiveDocuments && alctiveDocuments.length>0){
                            count =count+1;
                        }
                    }
                });
            }
        });
        if(count>0){
            return true
        }else{
            return false;
        }
    },
},
data() {
    return {
        tempData:null,
        filesDownloading:false,
        beneficiaryDocuments:{},
        usaDocumentsList:[],
        suposeDocuments:{},
        foreignDocsList:[],
        childrenDocuments:[],
        savedDocumentsList:[],
        isDocumentsAreSaved:false,
        downloadDocList:true,
        documentActiveTab:'savedDocuments',
        completeDocsSelected:false,
    }
},
methods: {
    closeMe(){
        this.$emit('closeMe')
    },
    savedDocumentsAction(callFromDownload=false){
    if(callFromDownload ==false){
    return ;
    }
    setTimeout(()=>{
    console.log('savedDocumentsAction')

    const $ = JQuery;
    let postData = { "petitionId":'', 'docList':[] ,"entityType": "case" ,"category": "other" };



    // alert(JSON.stringify(benCategoryOrders));

    postData = { "petitionId":'', 'docList':[] ,"entityType": "case" };
    let processDocuments =(documents ,category='usaCompanyDocuments' ,childrenId='' )=>{

    let benCategoryOrders ={};
    let benDocOrders ={};
    let supCategoryOrders ={};
    let chlCategoryOrders ={};
    if(category=='usaCompanyDocuments'){
        $("[id^='docTypeOrder_ben_']").each( (i, el)=> {
        
        let category = el.id.substr(17);
        benCategoryOrders[category] = i;
        
        });

        



    }

    if(category=='foreignCompanyDocuments'){
    $("[id^='docTypeOrder_sup_']").each( (i, el)=> {
    //   alert(el.id.substr(4))
    let category = el.id.substr(17);
    supCategoryOrders[category] = i;
    
    });
    
    }
    //  alert(category)
    if(category=='children'){ 
    $("[id^='docTypeOrder_"+childrenId+"_']").each( (i, el)=> {
    //   alert(el.id.substr(4))
    let id = el.id;
    let arr= id.split("_");
    if(arr.length>2){
        let category = arr[2];
    chlCategoryOrders[category] = i;
    }
    
    
    });
    //  alert(JSON.stringify(chlCategoryOrders));
    }
        _.forEach(
            documents,
        (item ,index)=> {
            
            if( this.checkProperty(item  ,'category')){
            if( this.checkProperty(item['documents'] ,'length')>0){
                let documentCategory =item['category'];
        
                let activeRecords = [];
                _.forEach(item['documents'] ,(doc)=>{
                    let order =1000000
                if(category=='usaCompanyDocuments'){
                    $("[id^='order_ben_"+documentCategory+"']").each( (i, el)=> {
                    
                    if(el.id){
                        let id =el.id;
                        //_docPath_
                        let docPathArr = id.split("_docPath_");
                        if(docPathArr.length>1){
                        let path =docPathArr[1];
                        if(path==doc['path']){
                            order =i;
                        }
                        
                        }
                    }
                    ;

                    })
                }else if(category=='foreignCompanyDocuments'){
                    $("[id^='order_sup_"+documentCategory+"']").each( (i, el)=> {
                    
                    if(el.id){
                        let id =el.id;
                        //_docPath_
                        let docPathArr = id.split("_docPath_");
                        if(docPathArr.length>1){
                        let path =docPathArr[1];
                        if(path==doc['path']){
                            order =i;
                        }
                        
                        }
                    }
                    

                    })
                } else if(category=='children'){ 
                    $("[id^='order_chi_"+documentCategory+"_"+childrenId+"']").each( (i, el)=> {
                        if(el.id){
                        let id =el.id;
                        //_docPath_
                        let docPathArr = id.split("_docPath_");
                        if(docPathArr.length>1){
                        let path =docPathArr[1];
                        if(path==doc['path']){
                            order =i;
                        }
                        
                        }
                    }
                        
                        
                        });

                }
                    
                let isAlreadyExista = _.find(postData['docList'] ,{'path':doc['path']});
                    if( doc['isSelected'] ){
                    
                    let docListItem ={
                        "path":doc['path'],
                        "order": order,
                        "docType": documentCategory,
                        "docTypeOrder": 10000,
                        "category": category,
                        "childrenId": childrenId,
                        "documentCategory":documentCategory



                    }
                    if(_.has(benCategoryOrders ,documentCategory) && category=='usaCompanyDocuments'){
                        docListItem['docTypeOrder'] =benCategoryOrders[documentCategory];
                    // alert(JSON.stringify(docListItem));
                    }else if(_.has(supCategoryOrders ,documentCategory) && category=='foreignCompanyDocuments'){
                        docListItem['docTypeOrder'] =supCategoryOrders[documentCategory];
                    // alert(JSON.stringify(docListItem));
                    }else if(category==='children' && _.has(chlCategoryOrders ,documentCategory)  ){
                        
                        docListItem['docTypeOrder'] =chlCategoryOrders[documentCategory];
                        //alert(JSON.stringify(docListItem));
                    } 
                    
                    postData['docList'].push(docListItem);
                    }

                })

                

                }
        }
                
        });
    }
    //beneficiaryDocuments:{}, suposeDocuments:{},childrenDocuments:[],
    processDocuments(this.usaDocumentsList ,"usaCompanyDocuments");
    processDocuments(this.foreignDocsList ,"foreignCompanyDocuments");

    let path ="/petition-common/save-docs-selected-config";
    let childrenDocs =_.filter(postData['docList'] ,{ 'category':'children'});
    // alert(JSON.stringify(childrenDocs));
    if(this.checkProperty(postData ,'docList','length') >0 && this.checkProperty(this.petition ,'_id')  ){
    postData['petitionId'] =this.petition._id;
    // path ="/petition/save-docs-selected-config";

    if(this.checkProperty(this.petition, 'type')==3 &&  [15].indexOf(this.checkProperty(this.petition,'subTypeDetails', 'id' )) >-1 ){
        //path ="/perm/save-docs-selected-config";
        postData['entityType'] ='perm'
    }

    
    
    this.$store.dispatch("commonAction" ,{data:postData,'path':path})
    .then((rx) =>{
    //  alert(JSON.stringify(rx));
    this.getSavedDocuments();


    }).catch((err)=>{
    //alert(err);
    })
    }

    },5);

    },
    downloadfile(item){
    let tempItem  =item
    tempItem = Object.assign( tempItem, {"viewmode":true});
    this.$emit('downloadfile' ,tempItem)
    },
    selectAll(type='usaDocumentsList',category='' ,childIndex=-1){
        if(type=='usaDocumentsList'){
        let categoryType = category;
        setTimeout(()=>{
        let findobj = _.find(this.usaDocumentsList, {'category':categoryType})
        let action = true;
        if(_.has(findobj, 'isSelected')){
            action = findobj['isSelected'];
        }
        this.usaDocumentsList.map((items)=>{
        if(_.has(items ,'category') && categoryType==items['category'] && _.has(items ,'documents') && items['documents'].length>0 ){
            items['documents'].map((item)=>{
            item['isSelected'] = action;
            });
        }
        });
        },10)
        }
        if(type=='foreignDocsList'){
        let categoryType = category;
        setTimeout(()=>{
        let findobj = _.find(this.foreignDocsList, {'category':categoryType})
        let action = true;
        if(_.has(findobj, 'isSelected')){
            action = findobj['isSelected'];
        }
        this.foreignDocsList.map((items)=>{
        if(_.has(items ,'category') && categoryType==items['category'] && _.has(items ,'documents') && items['documents'].length>0 ){
            items['documents'].map((item)=>{
            item['isSelected'] = action;
            });
        }
        });
        },10)
        }
        setTimeout(()=>{
        this.isCompleteDocsSelected()
        },100)
    },
    selectSingle(type='usaDocumentsList',category='' ,childIndex=-1){
        if(type == 'usaDocumentsList'){
        let categoryType = category;
        setTimeout(()=>{
        let self = this;
        let totalCount =0;
        let selectedCount =0;
        let unSelectedCount =0;
        _.forEach(this.usaDocumentsList, (item) => {
            if(_.has(item ,'category') && categoryType==item['category'] && _.has(item ,'documents') && item['documents'].length>0 ){
            _.forEach(item['documents'], (docItm)=>{
                totalCount = totalCount+1;
                if(_.has(docItm, 'isSelected') && docItm['isSelected']){
                selectedCount = selectedCount+1
                }else{
                unSelectedCount = unSelectedCount+1
                }
            })
            if(selectedCount>0 &&  unSelectedCount== 0 &&  selectedCount ==totalCount ){
                item['isSelected'] = true;
            }else{
                item['isSelected'] = false;
            }
            }
        });
        
        },10)
        }
        if(type == 'foreignDocsList'){
        let categoryType = category;
        setTimeout(()=>{
        let self = this;
        let totalCount =0;
        let selectedCount =0;
        let unSelectedCount =0;
        _.forEach(this.foreignDocsList, (item) => {
            if(_.has(item ,'category') && categoryType==item['category'] && _.has(item ,'documents') && item['documents'].length>0 ){
            _.forEach(item['documents'], (docItm)=>{
                totalCount = totalCount+1;
                if(_.has(docItm, 'isSelected') && docItm['isSelected']){
                selectedCount = selectedCount+1
                }else{
                unSelectedCount = unSelectedCount+1
                }
            })
            if(selectedCount>0 &&  unSelectedCount== 0 &&  selectedCount ==totalCount ){
                item['isSelected'] = true;
            }else{
                item['isSelected'] = false;
            }
            }
        });
        
        },10)
        }
        setTimeout(()=>{
            this.isCompleteDocsSelected()
        },100)
    },
    checkToSelectAll(type='usaDocumentsList'){
        let _self = this
        if(type=='usaDocumentsList'){
        setTimeout(()=>{
        this.usaDocumentsList.map((items)=>{
        if( _.has(items ,'documents') && items['documents'].length>0 ){
            let savedDocs=_.filter(items['documents'] ,{"isSelected":false});
            if(savedDocs && _self.checkProperty(savedDocs ,'length')>0){
            items['isSelected'] = false;
            }else{
            items['isSelected'] = true;
            }
        }else{
            items['isSelected'] = false;
        }
        });
        },10)
        }
        if(type=='foreignDocsList'){
        setTimeout(()=>{
        this.foreignDocsList.map((items)=>{
        if( _.has(items ,'documents') && items['documents'].length>0 ){
            let savedDocs=_.filter(items['documents'] ,{"isSelected":false});
            if(savedDocs && _self.checkProperty(savedDocs ,'length')>0){
            items['isSelected'] = false;
            }else{
            items['isSelected'] = true;
            }
        }else{
            items['isSelected'] = false;
        }
        });
        },10)
        }
        this.isCompleteDocsSelected()
    },
    moveToTrash(type='usaDocumentsList',category='' ,childIndex=-1){
        if(type=="usaDocumentsList"){
            this.usaDocumentsList.map((items)=>{
                if(_.has(items ,'category') && category==items['category'] && _.has(items ,'documents') && items['documents'].length>0 ){
                    items['documents'].map((item)=>{
                    item['isTrashDocument'] =true;
                    });
                }
            });

        }else if(type=="foreignDocsList"){
        this.foreignDocsList.map((items)=>{
        if(_.has(items ,'category') && category==items['category'] && _.has(items ,'documents') && items['documents'].length>0 ){
            items['documents'].map((item)=>{
            item['isTrashDocument'] =true;
            });
        }


        });

        }
    },
    moveToSave(type='usaDocumentsList',category='' ,childIndex=-1){
        if(type=="usaDocumentsList"){
            this.usaDocumentsList.map((items)=>{
                if(_.has(items ,'category') && category==items['category'] && _.has(items ,'documents') && items['documents'].length>0 ){
                    items['documents'].map((item)=>{
                    item['isTrashDocument'] =false;
                    });
                }
            });
        }else if(type=="foreignDocsList"){
            this.foreignDocsList.map((items)=>{
                if(_.has(items ,'category') && category==items['category'] && _.has(items ,'documents') && items['documents'].length>0 ){
                    items['documents'].map((item)=>{
                    item['isTrashDocument'] =false;
                    });
                }
            });
        }
    },
    changedDocumentsTab(tabName='savedDocuments'){
        this.documentActiveTab = tabName;
        setTimeout(()=>{
            this.updateLoading(false);
        } ,10);
    },
    getSavedDocuments(){
        let postData ={
        'petitionId':'',
        'entityType':'case',
        "category": "other"//"merge_all_docs" // other
        };
        postData['petitionId'] =this.petition._id;
        this.isDocumentsAreSaved =false;
        let path ="/petition/get-docs-selected-config";
        path ="/petition-common/get-docs-selected-config";
        if(this.checkProperty(this.petition, 'type')==3 &&  [15].indexOf(this.checkProperty(this.petition,'subTypeDetails', 'id' )) >-1 ){
            postData['entityType'] ='perm'
        }
        this.$store.dispatch("commonAction" ,{data:postData,'path':path})
        .then((rx) =>{
        if(rx){
            if(this.checkProperty( rx,'docList')){
                this.isDocumentsAreSaved =true;
                this.savedDocumentsList =_.cloneDeep(rx['docList']);
            }else{
                this.savedDocumentsList=[];
                this.isDocumentsAreSaved =false;
            }
        }else{
            this.savedDocumentsList=[];
            this.isDocumentsAreSaved =false;
        }
        this.init();
        }).catch((e)=>{
            this.savedDocumentsList=[];
            this.isDocumentsAreSaved =false;
            this.init();
        });
    },
    init(){
        let _self =this;
        this.beneficiaryDocuments ={};
        this.usaDocumentsList =[];
        this.suposeDocuments ={};
        this.foreignDocsList =[];
        this.childrenDocuments =[];
        let catDocuments =Object.entries(this.checkProperty(_self.petition, 'petitionerQuestInfo', 'usaCompanyDocuments'));
        let benFinalDocuments ={};
        _.forEach(catDocuments ,(item)=>{
            if(item.length>1){
                let category =_.cloneDeep(item[0]);
                let categoryOrders =null;
                if(item[1].length>0){
                    let documents =_.cloneDeep(item[1]);
                    let categoryDocuments =[];
                    _.forEach(documents ,(document)=>{
                        if(_self.checkProperty(document ,'status') !=false){
                            document = Object.assign(document ,{ "isTrashDocument":false});
                            document['isTrashDocument'] =false;
                            document['isSelected'] =true;
                            document['order']=100000;
                            document['docTypeOrder']=100000;
                            if(_self.isDocumentsAreSaved){
                                let bencategoryDocs = _.filter(_self.savedDocumentsList ,{'category':'usaCompanyDocuments'});
                                if(bencategoryDocs.length>0){
                                    categoryOrders = _.find(bencategoryDocs,{'docType':category ,'category':'usaCompanyDocuments'});
                                    let isSaveDoc = _.find(bencategoryDocs,{'path':document['path']});
                                    if(isSaveDoc && _.has(isSaveDoc ,'order')){
                                        document['order']= isSaveDoc['order'];

                                    }
                                    if(isSaveDoc && _.has(isSaveDoc ,'docTypeOrder')){
                                        document['docTypeOrder']= isSaveDoc['docTypeOrder'];

                                    }else  if(categoryOrders && _.has(categoryOrders ,'docTypeOrder')){
                                        document['docTypeOrder'] = categoryOrders['docTypeOrder'];
                                    }
                                    if(!isSaveDoc){
                                        document['isTrashDocument']=true;
                                        document['isSelected'] =false;
                                    }
                                }else{
                                    document['isSelected'] =false;
                                    document['isTrashDocument']=true;
                                }
                            }
                            categoryDocuments.push(_.cloneDeep(document));
                        }
                    })
                    if(categoryDocuments.length>0){
                        categoryDocuments =_.orderBy(categoryDocuments, ['order'],  ['asc']);
                        benFinalDocuments[category] = categoryDocuments;
                        if(!_.find(this.usaDocumentsList ,{'category':category})){
                            let tempData = {'isSelected':true,"category":category,"documents":categoryDocuments ,'docTypeOrder':1000000};
                            if(categoryOrders && _.has(categoryOrders ,'docTypeOrder')){
                                tempData['docTypeOrder'] = categoryOrders['docTypeOrder'];
                            }
                            this.usaDocumentsList.push(tempData);
                            this.usaDocumentsList =_.orderBy(this.usaDocumentsList, ['docTypeOrder'],  ['asc']);
                            this.checkToSelectAll('usaDocumentsList')
                        }
                    }
                }
            }
        });
        this.beneficiaryDocuments  =_.cloneDeep(benFinalDocuments);
        //process spouse documents
        if(_self.checkProperty( _self.petition ,"petitionerQuestInfo" ,'foreignCompanyDocuments')){
            if(_self.checkProperty(_self.petition['petitionerQuestInfo'],'foreignCompanyDocuments')){
                let catDocuments =Object.entries(_self.petition['petitionerQuestInfo']['foreignCompanyDocuments']);
                let spoUseFinalDocuments ={};
                _.forEach(catDocuments ,(item)=>{
                    if(item.length>1){
                        let category =_.cloneDeep(item[0]);
                        let categoryOrders =null; 
                        if(item[1].length>0){
                            let documents =_.cloneDeep(item[1]);
                            let spousecategoryDocuments =[];
                            _.forEach(documents ,(document)=>{
                            document['order']= 10000;
                            document['docTypeOrder'] =1000;
                            document['isSelected'] =true;
                                if(_self.checkProperty(document ,'status') !=false){
                                    document = Object.assign(document ,{ "isTrashDocument":false});
                                    if(_self.isDocumentsAreSaved){
                                        let spousecategoryDocs = _.filter(_self.savedDocumentsList ,{'category':'foreignCompanyDocuments'});
                                        if(spousecategoryDocs.length>0){
                                            categoryOrders = _.find(spousecategoryDocs,{'docType':category ,'category':'foreignCompanyDocuments'});
                                            let isSaveDoc = _.find(spousecategoryDocs,{'path':document['path']});
                                            if(isSaveDoc && _.has(isSaveDoc ,'order')){
                                                document['order']= isSaveDoc['order'];
                                            }
                                            if(isSaveDoc && _.has(isSaveDoc ,'docTypeOrder')){
                                                document['docTypeOrder']= isSaveDoc['docTypeOrder'];

                                            }else  if(categoryOrders && _.has(categoryOrders ,'docTypeOrder')){
                                                document['docTypeOrder'] = categoryOrders['docTypeOrder'];
                                            }
                                            if(!isSaveDoc){
                                                document['isSelected'] =false;
                                                document['isTrashDocument']=true;
                                            }
                                        }else{
                                            document['isSelected'] =false;
                                            document['isTrashDocument']=true;
                                        }
                                    }
                                    spousecategoryDocuments.push(_.cloneDeep(document));
                                }
                            })
                            if(spousecategoryDocuments.length>0){
                                spousecategoryDocuments =_.orderBy(spousecategoryDocuments, ['order'],  ['asc']);
                                spoUseFinalDocuments[category] = _.cloneDeep(spousecategoryDocuments);
                                if(!_.find(this.foreignDocsList ,{'category':category})){
                                    let tempData = {'isSelected':true,"category":category,"documents":spousecategoryDocuments ,'docTypeOrder':100000}
                                    if(categoryOrders && _.has(categoryOrders ,'docTypeOrder')){
                                        tempData['docTypeOrder'] = categoryOrders['docTypeOrder'];
                                    }
                                    this.foreignDocsList.push(tempData);
                                    this.foreignDocsList =_.orderBy(this.foreignDocsList, ['docTypeOrder'],  ['asc']);
                                    this.checkToSelectAll('foreignDocsList');
                                }
                            }
                        }
                    }
                });
                _self.suposeDocuments  =_.cloneDeep(spoUseFinalDocuments);
            }
        }
        setTimeout(()=>{
            this.updateLoading(false);
            setTimeout(()=>{
                this.updateLoading(false);
            } ,10);
            setTimeout(()=>{
                this.updateLoading(false);
                this.isCompleteDocsSelected()
            } ,10);
        },10);
    },
    downloadcombine() {
    let _APIURL = this.$globalgonfig._APIURL
    var self = this;
    var docs = [];
    let combailDocuments = (alDocs ,category='usaCompanyDocuments' ,childrenId='')=>{
    //{"category":category,"documents":categoryDocuments}
    let allDocuments =[];
    let categoryOrders ={}
    let order =1000000


    if(category=='usaCompanyDocuments'){
    $("[id^='docTypeOrder_ben_']").each( (i, el)=> {

    let category = el.id.substr(17);
    categoryOrders[category] = i;

    });


    }else if(category=='foreignCompanyDocuments'){
    $("[id^='docTypeOrder_sup_']").each( (i, el)=> {
    //   alert(el.id.substr(4))
    let category = el.id.substr(17);
    categoryOrders[category] = i;

    });

    }
    _.forEach(alDocs ,(tempList)=>{
        let documentCategory = tempList['category'];
        let trashedItems = _.filter(tempList['documents'] ,{isSelected:true});
        if(trashedItems && trashedItems.length>0){
            let item =trashedItems[0];
            if(item && _.has(item,'docTypeOrder')){
                tempList['docTypeOrder'] = item['docTypeOrder'];
            }else{
                tempList['docTypeOrder'] =100000;
            }
            if(_.has(categoryOrders ,documentCategory)){
                tempList['docTypeOrder'] =categoryOrders[documentCategory];
            }

            let tempDocuments =[];
            _.forEach(trashedItems ,(docItem)=>{
                if(category=='usaCompanyDocuments'){
                    $("[id^='order_ben_"+documentCategory+"']").each( (i, el)=> {
                    
                    if(el.id){
                        let id =el.id;
                        //_docPath_
                        let docPathArr = id.split("_docPath_");
                        if(docPathArr.length>1){
                        let path =docPathArr[1];
                        if(path==docItem['path']){
                            order =i;
                        }
                        
                        }
                    }
                    ;

                    })
                }else if(category=='foreignCompanyDocuments'){
                    $("[id^='order_sup_"+documentCategory+"']").each( (i, el)=> {
                    
                    if(el.id){
                        let id =el.id;
                        //_docPath_
                        let docPathArr = id.split("_docPath_");
                        if(docPathArr.length>1){
                        let path =docPathArr[1];
                        if(path==docItem['path']){
                            order =i;
                        }
                        
                        }
                    }
                    

                    })
                } 
                docItem['order'] = order;
                tempDocuments.push(docItem);
            })
            tempDocuments =_.orderBy(tempDocuments, ['order'],  ['asc']);
            tempList['documents'] =tempDocuments;
            allDocuments.push(tempList);
            allDocuments =_.orderBy(allDocuments, ['docTypeOrder'],  ['asc']);
        }
    });


    _.forEach(allDocuments ,(doc ,index)=> {

    if(this.checkProperty(doc ,'documents','length') >0){
    // if(this.checkProperty(doc[1] ,'length') >0){
    //alert(JSON.stringify(doc))

    doc['documents'].forEach(i=> {
        if(i.path!=null && i.path !='' && this.checkProperty(i ,'isSelected')   ){ 
        if(docs.indexOf(i.path)<=-1){
            docs.push(i.path);
        }
        
        }else if(i.url!=null && i.url !='' && this.checkProperty(i ,'isSelected')  ){ 
        if(docs.indexOf(i.path)<=-1){
            docs.push(i.path);
        }
        }
    })
    //}
    }
    })
    }

    combailDocuments(this.usaDocumentsList ,'usaCompanyDocuments' );
    combailDocuments(this.foreignDocsList ,'foreignCompanyDocuments' );
    let postdata = {
    petitionId: this.petition._id,
    documents: docs,
    };


    if(postdata['documents'].length>0){
    this.filesDownloading =true;
    let actionPath ="downloaddocsbyorder";
    if(this.checkProperty(this.petition, 'type')==3  && this.checkProperty(this.petition, 'subType')==15){
    actionPath ="downloaddocsbyorderPerm";
    }  

    this.$store
    .dispatch(actionPath, postdata)
    .then((response) => {
    this.savedDocumentsAction(true);
    this.filesDownloading =false;

    self.downloadDocumentPop = true;
    // alert( _APIURL+"/common/viewfile?path="+response.data.result.path);
    window.open(
    _APIURL+"/common/viewfile?path=" +
    response.data.result.path,
    "_blank"
    );
    }).catch((error)=>{
    this.filesDownloading =false;
    this.showToster({ message:error , isError: true})

    });

    } 
    },
    selectCompleteDocs(){
    this.usaDocumentsList.forEach(category => {
    category.isSelected=this.completeDocsSelected
    category.documents.forEach(doc => {
    doc.isSelected = this.completeDocsSelected;
    });
    });
    this.foreignDocsList.forEach(category => {
    category.isSelected=this.completeDocsSelected
    category.documents.forEach(doc => {
    doc.isSelected = this.completeDocsSelected;
    });
    });         
    this.childrenDocuments.forEach(child =>
    {
    child.documents.forEach(category => {
    category.isSelected=this.completeDocsSelected
    category.documents.forEach(doc => {
    doc.isSelected = this.completeDocsSelected;
    });
    });    
    });
    this.isCompleteDocsSelected()
    },
    isCompleteDocsSelected() {
    let allBenDocsSelected = true
    let allSpouseDocsSelected = true
    let allChildDocsSelected = true
    allBenDocsSelected = this.usaDocumentsList.every(category => { return category.documents.every(doc => doc.isSelected); });
    allSpouseDocsSelected = this.foreignDocsList.every(category => { return category.documents.every(doc => doc.isSelected); });

    allChildDocsSelected = this.childrenDocuments.every(child => {
    return child.documents.every(category => {
    return category.documents.every(subDoc => subDoc.isSelected);
    });
    });
    if(allBenDocsSelected && allSpouseDocsSelected && allChildDocsSelected){
    this.completeDocsSelected = true
    }else{
    this.completeDocsSelected = false
    }


    }




},
props: {
    loadedFromPreview:{type: Boolean , default: false},
    petition: {
        type: Object,
        default: null,
    }
},
mounted(){
    this.filesDownloading =false;
    setTimeout(()=>{
        this.getSavedDocuments();
    },10);
},
components:{
    draggable,
    VuePerfectScrollbar,
    NoDataFound,
    XIcon
},
watch:{
    downloadDocList:(val)=>{
        if(!val){
            this.$emit('closeMe');
        }
    }
}    
}
</script>
